// extracted by mini-css-extract-plugin
module.exports = {"list":"ItemsList-list-3504","regular":"ItemsList-regular-3504","stand":"ItemsList-stand-3504","busy":"ItemsList-busy-3504"};